// removed by extract-text-webpack-plugin
module.exports = {"battery":"battery__battery___On8SF","battery__text":"battery__battery__text___2V9gz","battery__lightning":"battery__battery__lightning___Bb2yc","battery__inner":"battery__battery__inner___1-x8S","battery__inner--low":"battery__battery__inner--low___3jKum"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Battery/battery.scss
// module id = 112
// module chunks = 0